import React from 'react';
import AdminLayout from '@app/layout/AdminLayout.tsx';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { RingilHeading } from '@components/styles.tsx';
import useTranslationLgs from '@hooks/i18n/useTranslation.tsx';
import AdminAuditLog from '@components/RingilComponents/audit/AdminAuditLog.tsx';

const IndexPage: React.FC = () => {
  const { tr } = useTranslationLgs();
  return (
    <AdminLayout title={tr('AdminAuditLog.pageTitle', 'Audit log')}>
      <RingilHeading>{tr('AdminAuditLog.pageTitle', 'Audit log')}</RingilHeading>
      <AdminAuditLog />
    </AdminLayout>
  );
};

export default withAuthenticationRequired(IndexPage);
